export const WelcomeStepPrograms = {
  transclude: true,

  bindings: {
    isLoading: '<',
    member: '<',
    scrollTo: '&',
    onSubmit: '&',
    onUpdate: '&',
  },

  template: `
    <div class="welcome welcome--profile">
      <h1 class="h2 text-center text-white my-4">
        Your Nutrition Profile
      </h1>
      <section class="bg-teal p-3 mb-5">
        <form class="voome-form voome-form--nutrition"
          name="form"
          ng-submit="$ctrl.onSubmit({ data: $ctrl.member })"
          novalidate>
          <div class="mb-3">
            <profile-container is-editing="true">
              <profile-fields-nutrition
                form="form"
                member="$ctrl.member"
                is-editing="true"
                on-update="$ctrl.onUpdate({ key: key, value: value })">
              </profile-fields-nutrition>
            </profile-container>
          </div>
          <div class="d-flex justify-content-center pt-4">
            <ng-transclude></ng-transclude>
          </div>
        </form>
      </section>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/WelcomeSteps/WelcomeStepPrograms.js